export default {
  'collectPoint.title': 'ポイントを集める',
  'collectPoint.success': 'ポイント取得成功',
  'collectPoint.obtained': '獲得済み',
  'collectPoint.point': 'ポイント',
  'collectPoint.enter_amount': '取引金額を入力してください',
  'collectPoint.enter_point': 'ポイント数を入力してください',
  'collectPoint.next_step': '次へ',
  'collectPoint.warning.NOT_REACH_THRESHOLD':
    'ポイント加算の基準に達していないため、取引記録のみを追加しました',
  'collectPoint.error.LOYALTY_CARD_NOT_ENABLED': 'ポイント活動が有効化されていません',
  'collectPoint.error.LOYALTY_CARD_NOT_FOUND': 'ポイント活動情報エラー',
  'collectPoint.error.SHOP_NOT_FOUND': '店舗情報エラー',
  'collectPoint.error.FLEXIBLE_DEDUCTION_NOT_ENABLED': 'この活動ではポイント控除はできません',
  'collectPoint.error.SEND_RULE_NOT_FLEXIBLE_SEND': '送信情報エラー',
  'collectPoint.error.NOT_ENOUGH_POINT_FOR_DEDUCT': 'ポイント不足で控除できません',
  'collectPoint.error.PARTIAL_SEND_POINT_FAILED': '一部会員へのポイント付与に失敗しました',
  'collectPoint.error.PARTIAL_DEDUCT_POINT_FAILED': '一部会員のポイント控除に失敗しました',
  'collectPoint.error.LOYALTY_CARD_SHOP_ERROR': '店舗が対象ポイントカードの制限店舗に一致しません',
  'collectPoint.error.ACCOUNT_SHOP_NOT_ELIGIBLE':
    '操作アカウント所属店舗が対象ポイントカードの制限店舗に一致しません',
  'collectPoint.error.VALIDATE_SEND_POINTS_LIMIT_IN_DAYS_FAILED':
    '1日のポイント付与制限を超えました',
  'collectPoint.error.AMOUNT_TO_MPS_CARD_POINT_FAILED': '付与失敗',
  'collectPoint.error.PARAMETERS_ERROR': '情報エラー',
  'collectPoint.error.MEMBER_PHONE_NOT_FOUND': '電話番号が存在しません',
  'collectPoint.error.MEMBER_NOT_FULL': '正会員ではありません',
  'collectPoint.error.INTERNAL_SERVER_ERROR':
    'エラーが発生しました。しばらくしてから再試行してください',
} as Record<string, string>;
